import React, { FunctionComponent, ReactElement } from "react";
import { I18n } from "react-redux-i18n";

import "./Metrics.css";

interface MetricsItem {
  title: string;
  subTitle?: string;
  value: string | ReactElement;
  color?: string;
}

interface MetricsProps {
  items: MetricsItem[];
}

export const Metrics: FunctionComponent<MetricsProps> = ({
  items,
}) => {
  return (
    <div className="metrics-container">
      {items.map(({
        title,
        subTitle,
        value,
        color,
      }) => (
        <div
          className="metric"
          style={{ backgroundColor: color ? color : "var(--card-bg)" }}
        >
          <div className="metric-header">
            <h5>{I18n.t(title)}</h5>
            {subTitle && <span>{I18n.t(subTitle)}</span>}
          </div>
          <h1 className="metric-value">
            {value}
          </h1>
        </div>
      ))}
    </div>
  );
};
